import { getTenantFromUrl } from './tenantUtils';

const originalFetch = window.fetch;

window.fetch = async (input, init = {}) => {
  const tenant = getTenantFromUrl();
  
  let url = '';
  if (typeof input === 'string') {
    url = input;
  } else if (input && typeof input === 'object' && input.url) {
    url = input.url;
  }

  const isInternal = !url.startsWith('http') || 
    url.includes('localhost') || 
    url.includes('127.0.0.1') || 
    url.includes('virtualselect.in') || 
    url.includes('hostingersite.com') || 
    url.includes('azurewebsites.net');

  const isExternal = !isInternal;

  // Create a new Headers object or clone existing ones
  let headers = new Headers(init.headers || {});
  
  if (!isExternal) {
    // Inject Tenant ID if present
    if (tenant) {
      headers.set('X-Tenant-ID', tenant);
    }
  }

  // Also safely ensure token is passed if available, 
  // since this intercepts all fetches.
  if (!isExternal) {
    try {
      const rawUser = localStorage.getItem('user');
      if (rawUser) {
        const user = JSON.parse(rawUser);
        if (user && user.token && !headers.has('Authorization')) {
          headers.set('Authorization', `Bearer ${user.token}`);
        }
      }
    } catch (e) {
      // Ignore parse errors
    }
  }

  // Assign the new headers back to init
  init.headers = headers;

  return originalFetch(input, init);
};
